// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';
import Button from '../components/Button';
import NextArrowImage from '../assets/images/next-page-arrow.svg';
import PreviousArrowImage from '../assets/images/previous-page-arrow.svg';

// Styled Component

const S = {
  Container: styled.div`
    button + button {
      margin-left: 16px;
    }
  `,
  Button: styled(Button).attrs({ theme: 'white' })`
    width: 28px;
    height: 28px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;
    font: bold 12px / 18px 'Noto Sans TC';
    letter-spacing: 0.19px;
    cursor: pointer;
  `,
  MorePage: styled.span`
    margin: 0 16px;
  `,
  PreviousArrowImg: styled.img.attrs({ src: PreviousArrowImage, alt: '' })<{ page: number }>`
    position: relative;
    right: 35px;
    visibility: ${({ page }) => page > 1 ? 'visible' : 'hidden'};
    cursor: pointer;
  `,
  NextArrowImg: styled.img.attrs({ src: NextArrowImage, alt: '' })<{ page: number; pageLength: number }>`
    position: relative;
    left: 35px;
    visibility: ${({ page, pageLength }) => page < pageLength ? 'visible' : 'hidden'};
    cursor: pointer;
  `,
}

interface Props extends React.ComponentProps<any> {
  pageLength: number;
  page: number;
  onClick: (arg: number) => void;
}

const Pagination = ({ pageLength, page, onClick, style, ...props }: Props) => {
  const handleDecrease = () => {
    onClick(page - 1);
  };

  const handleIncrease = () => {
    onClick(page + 1);
  };

  const handleClick = (e: any) => {
    const { value } = e.target;
    if (value != page) {
      onClick(parseInt(value, 10));
    }
  };

  const renderItem = () => {
    for (let i = 1; i <= pageLength; i += 1) {
      if (i < 3 || Math.abs(i - page) < 2 || pageLength - i < 2) {
        item.push(
          <S.Button
            key={i}
            active={i === page}
            value={i}
            onClick={handleClick}
          >
            {i}
          </S.Button>
        );
      } else if (Math.abs(i - page) == 2) {
        item.push(<S.MorePage>...</S.MorePage>);
      }
    }
  };

  const item: any = [];
  renderItem();

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', position: 'relative', ...style }}
      {...props}
    >
      <S.PreviousArrowImg
        onClick={handleDecrease}
        page={page}
      />

      <S.Container>{item}</S.Container>

      <S.NextArrowImg
        onClick={handleIncrease}
        page={page}
        pageLength={pageLength}
      />
    </div>
  );
};

export default Pagination;
